import TeenInstantPage from "./TeenInstantPage";

// casino/teen33 — reference title "Instant Teenpatti 3.0" (shared Instant Teenpatti page)
export default function TeenPatti33() {
  return <TeenInstantPage defaultType="teen33" title="Instant Teenpatti 3.0" />;
}
